// Icônes SVG par catégorie + helpers pour les marqueurs Leaflet.
// Inspirées de la bibliothèque Lucide (https://lucide.dev) pour la lisibilité
// à petite taille (rendues à ~23px dans le marqueur final).
// Chaque icône utilise currentColor pour hériter du blanc.

const ICONS = {
  // Cône de signalisation — symbole universel des travaux et de la voirie
  voirie: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round">
    <path d="M10 4 L7 20 H17 L14 4 Z"/>
    <line x1="7.5" y1="16" x2="16.5" y2="16"/>
    <line x1="8.5" y1="12" x2="15.5" y2="12"/>
    <line x1="9.5" y1="8" x2="14.5" y2="8"/>
    <line x1="5" y1="20" x2="19" y2="20"/></svg>`,

  // Poubelle nette (style trash-2 de Lucide)
  proprete: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round">
    <path d="M3 6 H21"/>
    <path d="M8 6 V4 a2 2 0 0 1 2 -2 h4 a2 2 0 0 1 2 2 V6"/>
    <path d="M19 6 l-1 14 a2 2 0 0 1 -2 2 H8 a2 2 0 0 1 -2 -2 L5 6"/>
    <line x1="10" y1="11" x2="10" y2="17"/>
    <line x1="14" y1="11" x2="14" y2="17"/></svg>`,

  // Lampadaire urbain — pôle vertical + tête lumineuse + base solide
  eclairage: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round">
    <rect x="8" y="3" width="8" height="5" rx="1" fill="currentColor" fill-opacity="0.4"/>
    <line x1="12" y1="8" x2="12" y2="21"/>
    <line x1="9" y1="21" x2="15" y2="21"/>
    <path d="M10 11 L8 13" stroke-width="1.5"/>
    <path d="M14 11 L16 13" stroke-width="1.5"/></svg>`,

  // Arbre style "pine tree" — silhouette plus identifiable
  espaces_verts: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round">
    <path d="M12 2 L7 10 H10 L6 16 H10 L5 22 H19 L14 16 H18 L14 10 H17 Z"
          fill="currentColor" fill-opacity="0.35"/></svg>`,

  // Banc public — plan d'assise + dossier + pieds
  mobilier: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round">
    <line x1="3" y1="11" x2="21" y2="11" stroke-width="2.5"/>
    <line x1="3" y1="14" x2="21" y2="14" stroke-width="2.5"/>
    <line x1="5" y1="14" x2="5" y2="20"/>
    <line x1="19" y1="14" x2="19" y2="20"/>
    <line x1="5" y1="11" x2="5" y2="7"/>
    <line x1="19" y1="11" x2="19" y2="7"/></svg>`,

  // Cercle d'information (style "info" de Lucide) — plus clair qu'un point d'interrogation
  autre: `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
    stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="10"/>
    <line x1="12" y1="11" x2="12" y2="17"/>
    <circle cx="12" cy="7.5" r="1" fill="currentColor" stroke="none"/></svg>`,
};

export const STATUS_COLORS = {
  en_attente_validation: "#b88a2e",
  nouveau: "#b54b3a",
  pris_en_compte: "#d9a521",
  en_cours: "#1d4f91",
  resolu: "#2f7d4f",
  refuse: "#888",
};

export function getCategoryIcon(cat) {
  return ICONS[cat] || ICONS.autre;
}

/**
 * Construit un divIcon Leaflet :
 *  - fond rond coloré selon le STATUT
 *  - SVG d'icône de catégorie en blanc dedans
 *  - pulsation si statut "nouveau"
 *  - taille variable selon sélection
 */
export function buildMarkerIcon(L, categorie, statut, { selected = false } = {}) {
  const color = STATUS_COLORS[statut] || "#666";
  const svg = getCategoryIcon(categorie);
  const size = selected ? 46 : 38;
  const pulse = statut === "nouveau" || statut === "en_attente_validation";
  const html = `
    <div class="sig-marker ${pulse ? 'sig-marker-pulse' : ''}"
         style="width:${size}px; height:${size}px; background:${color};
                ${selected ? 'box-shadow:0 0 0 3px rgba(0,0,0,0.25), 0 3px 8px rgba(0,0,0,0.5);' : ''}">
      <span class="sig-marker-svg" style="color:#fff; width:60%; height:60%;
            display:flex; align-items:center; justify-content:center;">${svg}</span>
    </div>`;
  return L.divIcon({
    html, className: "",
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -size / 2],
  });
}
